import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Notti intere a creare slide ed esercizi da zero.',
  good: 'Codice pulito e soluzioni pronte sul tuo tablet in 2 clic.'
}, {
  bad: 'Stress prima di spiegare algoritmi a classi distratte.',
  good: 'Sicurezza totale con schemi logici pronti da proiettare.'
}, {
  bad: 'Spiegazioni che gli studenti trovano impossibili da seguire.',
  good: 'Supporti visivi moderni con progetti pratici reali.'
}, {
  bad: 'Weekend sacrificati a preparare verifiche e correggere codice.',
  good: 'Verifiche pronte con soluzionario: correggi in metà del tempo.'
}, {
  bad: 'Difficoltà a coinvolgere studenti DSA e BES nel coding.',
  good: 'Schede differenziate Base / Intermedio / Avanzato già pronte.'
}];
export function ComparisonTable() {
  return <section className="py-8 px-4" data-id="element-56">
      <div className="max-w-xl mx-auto" data-id="element-57">
        <div className="space-y-3" data-id="element-58">
          {comparisons.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-2xl p-4 space-y-2.5" data-id="element-59">
              <div className="flex gap-3 items-start" data-id="element-60">
                <div className="mt-0.5 bg-red-500/15 p-1 rounded-full shrink-0" data-id="element-61">
                  <XIcon className="w-4 h-4 text-red-500" strokeWidth={3} data-id="element-62" />
                </div>
                <p className="text-gray-400 font-medium text-sm sm:text-base" data-id="element-63">
                  {item.bad}
                </p>
              </div>
              <div className="flex gap-3 items-start" data-id="element-64">
                <div className="mt-0.5 bg-green-500/15 p-1 rounded-full shrink-0" data-id="element-65">
                  <CheckIcon className="w-4 h-4 text-green-500" strokeWidth={3} data-id="element-66" />
                </div>
                <p className="text-brand-cream font-bold text-sm sm:text-base" data-id="element-67">
                  {item.good}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-lg font-bold text-brand-orange mt-8 mb-6" data-id="element-68">
          Smetti di reinventare la ruota ogni settimana. Riprenditi il tuo
          tempo.
        </motion.p>
      </div>
    </section>;
}